/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteVehicleImagesParams,
  GetVehicleImagesParams,
  PatchVehicleImagesParams,
  PostVehicleImagesParams,
  PostgrestError,
  VehicleImages,
  VehicleImagesInsertPayload,
  VehicleImagesUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getVehicleImagesResponse200 = {
  data: VehicleImages[]
  status: 200
}

export type getVehicleImagesResponse206 = {
  data: VehicleImages[]
  status: 206
}

export type getVehicleImagesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getVehicleImagesResponseSuccess = (getVehicleImagesResponse200 | getVehicleImagesResponse206) & {
  headers: Headers;
};
export type getVehicleImagesResponseError = (getVehicleImagesResponseDefault) & {
  headers: Headers;
};

export type getVehicleImagesResponse = (getVehicleImagesResponseSuccess | getVehicleImagesResponseError)

export const getGetVehicleImagesUrl = (params?: GetVehicleImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicle_images?${stringifiedParams}` : `${backendBaseUrl}/vehicle_images`
}

/**
 * @summary Read rows from `vehicle_images`.
 */
export const getVehicleImages = async (params?: GetVehicleImagesParams, options?: RequestInit): Promise<getVehicleImagesResponse> => {

  const res = await fetch(getGetVehicleImagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVehicleImagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVehicleImagesResponse
}


export type postVehicleImagesResponse201 = {
  data: VehicleImages[]
  status: 201
}

export type postVehicleImagesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postVehicleImagesResponseSuccess = (postVehicleImagesResponse201) & {
  headers: Headers;
};
export type postVehicleImagesResponseError = (postVehicleImagesResponseDefault) & {
  headers: Headers;
};

export type postVehicleImagesResponse = (postVehicleImagesResponseSuccess | postVehicleImagesResponseError)

export const getPostVehicleImagesUrl = (params?: PostVehicleImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicle_images?${stringifiedParams}` : `${backendBaseUrl}/vehicle_images`
}

/**
 * @summary Insert one or more rows into `vehicle_images`.
 */
export const postVehicleImages = async (vehicleImagesInsertPayload: VehicleImagesInsertPayload,
    params?: PostVehicleImagesParams, options?: RequestInit): Promise<postVehicleImagesResponse> => {

  const res = await fetch(getPostVehicleImagesUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vehicleImagesInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postVehicleImagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postVehicleImagesResponse
}


export type patchVehicleImagesResponse200 = {
  data: VehicleImages[]
  status: 200
}

export type patchVehicleImagesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchVehicleImagesResponseSuccess = (patchVehicleImagesResponse200) & {
  headers: Headers;
};
export type patchVehicleImagesResponseError = (patchVehicleImagesResponseDefault) & {
  headers: Headers;
};

export type patchVehicleImagesResponse = (patchVehicleImagesResponseSuccess | patchVehicleImagesResponseError)

export const getPatchVehicleImagesUrl = (params?: PatchVehicleImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicle_images?${stringifiedParams}` : `${backendBaseUrl}/vehicle_images`
}

/**
 * @summary Update the rows of `vehicle_images` matching the given filters.
 */
export const patchVehicleImages = async (vehicleImagesUpdate: VehicleImagesUpdate,
    params?: PatchVehicleImagesParams, options?: RequestInit): Promise<patchVehicleImagesResponse> => {

  const res = await fetch(getPatchVehicleImagesUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vehicleImagesUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchVehicleImagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchVehicleImagesResponse
}


export type deleteVehicleImagesResponse200 = {
  data: VehicleImages[]
  status: 200
}

export type deleteVehicleImagesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteVehicleImagesResponseSuccess = (deleteVehicleImagesResponse200) & {
  headers: Headers;
};
export type deleteVehicleImagesResponseError = (deleteVehicleImagesResponseDefault) & {
  headers: Headers;
};

export type deleteVehicleImagesResponse = (deleteVehicleImagesResponseSuccess | deleteVehicleImagesResponseError)

export const getDeleteVehicleImagesUrl = (params?: DeleteVehicleImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicle_images?${stringifiedParams}` : `${backendBaseUrl}/vehicle_images`
}

/**
 * @summary Delete the rows of `vehicle_images` matching the given filters.
 */
export const deleteVehicleImages = async (params?: DeleteVehicleImagesParams, options?: RequestInit): Promise<deleteVehicleImagesResponse> => {

  const res = await fetch(getDeleteVehicleImagesUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteVehicleImagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteVehicleImagesResponse
}


